import { Injectable } from '@angular/core';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { ExternalUserFlatListQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-flat-list-query.dto';
import type { ExternalUserInviteOneQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-invite-one-query.dto';
import type { ExternalUserPageListQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-page-list-query.dto';
import type { ExternalUserPageInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-page.dto';
import type { RoomAccessFindInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-find.dto';
import type { RoomAccessFormInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-form.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalUserService extends BaseService {
  protected baseUrl = '/basis/security/external-user';

  public findManyFlat(params?: ExternalUserFlatListQueryInterface): Observable<ExternalUserFindInterface[]> {
    return this.http.get<ExternalUserFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public findManyPage(params?: ExternalUserPageListQueryInterface): Observable<ExternalUserPageInterface> {
    return this.http.get<ExternalUserPageInterface>(`${this.baseUrl}/page`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public inviteOne(id: number, params?: ExternalUserInviteOneQueryInterface): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/invite`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public ban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/ban`, null);
  }

  public unban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/unban`, null);
  }

  public getPacsAccess(id: number): Observable<RoomAccessFindInterface> {
    return this.http.get<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`);
  }

  public setPacsAccess(id: number, body: RoomAccessFormInterface): Observable<RoomAccessFindInterface> {
    return this.http.put<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`, body);
  }
}
